package com.karyadina.model

import kotlinx.serialization.Serializable

/**
 * Scan mode for text extraction
 */
enum class ScanMode {
    QUESTION,  // Extract text for question
    ANSWER,    // Extract text for answer
    IMAGE_ONLY, // Save image only, no text extraction
    FORMULA    // Recognize and render mathematical formula
}

/**
 * Scan result with extracted text and image
 */
data class ScanResult(
    val extractedText: String?,
    val imagePath: String?,
    val mode: ScanMode,
    val success: Boolean,
    val errorMessage: String? = null
)

/**
 * Camera permission state
 */
enum class CameraPermissionState {
    GRANTED,
    DENIED,
    NOT_REQUESTED
}
